export const FAIL_STATUS = 3;
export const SUCCESS_STATUS = 2;
export const COMPANY_METHOD = 3;
export const BANK_CARD_METHOD = 2;
export const ALIPAY_METHOD = 1;

export const STATUS_MAP = {
  1: '提现中',
  [SUCCESS_STATUS]: '提现成功',
  [FAIL_STATUS]: '提现失败',
};

export const TYPE_MAP = {
  [ALIPAY_METHOD]: '支付宝',
  [BANK_CARD_METHOD]: '银行卡',
  [COMPANY_METHOD]: '公司账户',
};

export const INVOICE_MAP = {
  0: '未提供',
  1: '已提供',
};

export const statusMap = {
  1: '提现中',
  2: '提现成功',
  3: '提现失败',
};

export const typeMap = {
  1: '支付宝',
  2: '银行卡',
  3: '公司账户',
};

export const PAGE_SIZE = 20;

export const companyRules = [
  {
    title: '提现方式',
    content:
      '使用认证信息里的开户银行对公转账，提现将于提现日后两个工作日内到账。如超时未到账，请联系银行客服检查账户状态是否封禁、限制收款等。',
  },
  {
    title: '提现时间',
    content: '每周二（10:00-18:00）可进行提现，如遇节假日顺延至下周。',
  },
  {
    title: '提现限制',
    content: '银行账户一旦确认不支持变更。',
  },
  {
    title: '提现发票',
    content: `
    <p>企业提现完成后，下月提现前需提供本月增值税专用发票，否则将无法提现，发票详细内容如下： </p>
    <ul style="padding-left: 0.2rem">
    <li>
    <p><strong>(1) 发票内容：</strong></p>
      <p><strong>货物或应税劳务、服务名称：</strong>信息技术服务费/电信技术服务费/网络技术服务费等</p>
      <p><strong>公司名称：</strong>深圳市网心科技有限公司</p>
      <p><strong>税号：</strong>91440300053965375W</p>
      <p><strong>社会信用代码：</strong>91440300053965375W</p>
      <p><strong>地址、电话：</strong>深圳市前海深港合作区前湾一路1号A栋201室（入驻深圳市前海商务秘书有限公司）<br/>0755-86240911</p>
      <p><strong>开户银行及账号：</strong>招商银行深圳蛇口支行755920273010903</p>
    </li>
    <li><strong>(2) 发票提供时间：</strong>每个自然月最后一次提现后的五日内需快递到网心科技 （例如6月份的发票需在7月5日前寄到网心科技，7月份的发票需在8月2日前寄到网心科技），我方将在收到发票后的7个工作日内审核完成，发票验证合格后，可继续提现，若延迟提供将影响您的提现进度；</li>
    <li><strong>(3) 开票金额必须与当月的提现金额完全一致且准确到分，如5386.26元；</strong></li>
    <li>
        <p><strong>(4) 增值税专用发票需快递至网心科技（请使用顺丰快递，其他快递易丢件，影响提现进度；拒签到付或平邮件，敬请谅解），收件信息：</p>
        <p><strong>收件人：</strong>网心云发票组  <br/><strong>联系电话：</strong>13632795680<strong>（仅供收件使用，咨询请联系在线客服）</strong></p>
        <p><strong>收件地址：</strong>深圳市南山区粤海街道高新区社区科技南路18号深圳湾科技生态园12栋B座23层（推荐顺丰，其他快递易丢件，若快递丢失需复印件加盖发票专用章，重新邮寄）</p>
    </li>
    <li>
    <strong>(5) 其他问题请联系官网<a href="/#" id="service-button">在线客服</a>（9：00-22：00）</strong>
    </li>
    </ul>`,
  },
];

export const TEMP_PERSONAL_RULE = [
  {
    title: '提现时间：',
    content: '每周二（10-00--18:00）可进行提现，如遇节假日则顺延至下周。',
  },
  {
    title: '提现方式与金额：',
    content: `<ul>
        <li>无提现额度限制，用户可根据提现金额选择适合的提现方式。</li>
        <li>
          ①
          每月低于800元的提现，支持支付宝、银行卡提现，支付宝提现免费，银行卡提现每笔将扣除7%+1元的服务费；
        </li>
        <li>② 每月高于800元的提现，支持银行卡提现，每笔提现将扣除7%+1元的服务费。</li>
      </ul>`,
  },
];

export const getPersonRules = (withdrawRule = {}) => {
  const { extraFee, feeRate } = withdrawRule;
  const defaultText = 0;
  const resExtraFee = extraFee ? extraFee / 100 : defaultText;
  const resFeeRate = feeRate ? (feeRate * 100).toFixed(2) : defaultText;
  const resExtraFeeText = resExtraFee ? `+${resExtraFee}元` : '';
  // const fixedRate = 6;
  // const resRate = feeRate ? (resFeeRate - 6).toFixed(2) : defaultText;
  const personRules = [
    {
      title: '提现时间',
      content: '每周二（10:00--18:00）可进行提现，如遇节假日顺延至下周。',
    },
    {
      title: '提现方式',
      content: `<ul>
        <li>
        用户可根据提现金额选择适合的提现方式：
        </li>
        <li>
        ① 每月提现不超过800元时，支持支付宝（推荐）、银行卡提现，支付宝提现免费，银行卡提现每笔将扣除${resFeeRate}%${resExtraFeeText}的服务费；
        </li>
        <li>
        ② 每月提现高于800元时，支持银行卡提现，每笔提现将扣除${resFeeRate}%${resExtraFeeText}的服务费。
        </li>
        </ul>`,
    },
    {
      title: '温馨提示',
      content:
        '您的提现取得的收入，我们将会按税法规定代扣代缴个人所得税，因此您需提供个人有效身份证信息和真实姓名。',
    },
  ];
  return personRules;
};

export const DEFAULT_TEXT = 0;
